// export const PATH = 'http://47.103.103.32:8001';   // 线上服务器地址路径
// export const PATH = 'http://www.jxbdszkj.com';   // 本地服务器地址路径
export const ImgUrl = '';   //图片地址
export const PATH = 'http://114.132.50.11/ifb';   // 服务器地址路径
// export const PATH = 'http://localhost:8011';   // 本地服务器地址路径
// export const PATH = '/api';   // 服务器地址路径

export const MAP_KEY = 'JACBZ-N6EK6-IO4S7-ESP4S-3E3RS-OCFDM';   // 腾讯地图key
export const Height = document.documentElement.clientHeight || document.body.clientHeight;   // 屏幕可用高度
export const Width =  document.documentElement.clientWidth || document.body.clientWidth;   // 屏幕可用宽度
